import axios from "axios/index";

const baseURL = "https://explorer.ont.io/v2"; // "https://polarisexplorer.ont.io/v2"; // "https://explorer.ont.io/v2"

export default {
  state: {
    summary: {},
    maplist: {},
    nodelist: [],
    blockstonextround: 0,
    totalstake: {},
    totalsupply: {},
    offnodelist: {},
    rankchangelist: [],
    annualList: {},
    showToolTip: false,
  },
  getters: {
    nodeSummary: (state) => state.summary,
    nodeMapList: (state) => state.maplist,
    NodeList: (state) => state.nodelist,
    offNodeList: (state) => state.offnodelist,
    blockstonext: (state) => state.blockstonextround,
    totalstakeamount: (state) => state.totalstake,
    totalsupply: (state) => state.totalsupply,
    rankchangelist: (state) => state.rankchangelist,
    annualList: (state) => state.annualList,
  },
  mutations: {
    setShowToolTip(state, payload) {
      state.showToolTip = payload;
    },
    setNodeSummary(state, payload) {
      state.summary = payload;
    },
    setNodeMapList(state, payload) {
      state.maplist = payload;
    },
    setNodeList(state, payload) {
      state.nodelist = payload;
    },
    setOffNodeList(state, payload) {
      state.offnodelist = payload;
    },
    setBlocksToNextRound(state, payload) {
      state.blockstonextround = payload;
    },
    setTotalStake(state, payload) {
      state.totalstake = payload;
    },
    setTotalSupply(state, payload) {
      state.totalsupply = payload;
    },
    setRankChangeList(state, payload) {
      state.rankchangelist = payload;
    },
    setAnnualList(state, payload) {
      state.annualList = payload;
    },
  },
  actions: {
    async getTotalStake({ commit }) {
      let url = baseURL + "/nodes/current-total-stakes";
      let ret = await axios.get(url);
      commit("setTotalStake", ret.data.result);
    },
    async getTotalSupply({ commit }) {
      let url =
        "https://explorer.ont.io/api/v1/explorer/summary/native/totalsupply";
      let ret = await axios.get(url);
      commit("setTotalSupply", ret.data.result);
    },
    async getNodeSummary({ commit }) {
      let url = baseURL + "/nodes/count";
      let ret = await axios.get(url);
      commit("setNodeSummary", ret.data.result);
    },
    async getBlocksToNextRound({ commit }) {
      let url = baseURL + "/nodes/block-count-to-next-round";
      let ret = await axios.get(url);
      commit("setBlocksToNextRound", ret.data.result);
    },
    async getNodeMapList({ commit }) {
      let url = baseURL + "/nodes/all-in-network";
      let ret = await axios.get(url);
      commit("setNodeMapList", ret.data.result || {});
    },
    async getNodeList({ commit }) {
      let url = baseURL + "/nodes/current-stakes";
      let ret = await axios.get(url);
      commit("setNodeList", ret.data.result);
    },
    async getOffNodeList({ commit }) {
      let url = baseURL + "/nodes/off-chain-infos";
      let ret = await axios.get(url);
      commit("setOffNodeList", ret.data.result);
    },
    async getRankChangeList({ commit }) {
      let url = baseURL + "/nodes/rank-change";
      let ret = await axios.get(url);
      commit("setRankChangeList", ret.data.result);
    },
    async getAnnualList({ commit }) {
      let url = baseURL + "/nodes/inspire/all?page_number=1&page_size=400";
      let ret = await axios.get(url);
      commit("setAnnualList", ret.data.result);
    },
  },
};
